import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * PublicRoute component for routes that should only be accessible when NOT authenticated
 * If user is authenticated, redirects to /dashboard
 * If user is not authenticated, renders the children component
 */
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-blueGray-600">Loading...</div>
      </div>
    );
  }

  // If user is authenticated, redirect to dashboard
  if (isAuthenticated) {
    return <Redirect to="/dashboard" />;
  }

  // Otherwise, show the public route
  return children;
};

export default PublicRoute;
